export default __webpack_public_path__ + "static/media/bg-success.c22e40d6.webp";